export default "/static/webpack/images/favicons/favicon.ico";